export interface ContenusCompleteState {
  selectionGroupe: number[];
  selectionOrganisation: number[];
  selectionTitreContenu: string[];
  selectionEtiquette: number[];
  selectionDateAcces: string;
  selectionFormationGroupe: string;
  textRechercher: string;
  dateDebut: Date;
  dateFin: Date;
  groupeIdsSelection: string[];
  organisationIdsSelection: string[];
  etiquetteIdsSelection: string[];
  contenusSelection: string[];
  pageIndex: number;
  pageSize: number;
}

export const defaultContenusCompleteState: ContenusCompleteState = {
  selectionGroupe: [],
  selectionOrganisation: [],
  selectionTitreContenu: [],
  selectionEtiquette: [],
  selectionDateAcces: 'last30days',
  selectionFormationGroupe: '',
  textRechercher: '',
  dateDebut: new Date(),
  dateFin: new Date(),
  groupeIdsSelection: [],
  organisationIdsSelection: [],
  etiquetteIdsSelection: [],
  contenusSelection: [],
  pageIndex: 0,
  pageSize: 10
};

export function validateContenusCompleteState(state: any): ContenusCompleteState {
  if (!state || typeof state !== 'object') {
    return { ...defaultContenusCompleteState };
  }

  return {
    selectionGroupe: Array.isArray(state.selectionGroupe) ? state.selectionGroupe : [],
    selectionOrganisation: Array.isArray(state.selectionOrganisation) ? state.selectionOrganisation : [],
    selectionTitreContenu: Array.isArray(state.selectionTitreContenu) ? state.selectionTitreContenu : [],
    selectionEtiquette: Array.isArray(state.selectionEtiquette) ? state.selectionEtiquette : [],
    selectionDateAcces: ['alldate', 'today', 'yesterday', 'week', 'last30days', 'year', 'custom'].includes(state.selectionDateAcces) ? state.selectionDateAcces : 'last30days',
    selectionFormationGroupe: ['', 'groupe', 'individuel'].includes(state.selectionFormationGroupe) ? state.selectionFormationGroupe : '',
    textRechercher: typeof state.textRechercher === 'string' ? state.textRechercher : '',
    dateDebut: state.dateDebut ? new Date(state.dateDebut) : new Date(),
    dateFin: state.dateFin ? new Date(state.dateFin) : new Date(),
    groupeIdsSelection: Array.isArray(state.groupeIdsSelection) ? state.groupeIdsSelection : [],
    organisationIdsSelection: Array.isArray(state.organisationIdsSelection) ? state.organisationIdsSelection : [],
    etiquetteIdsSelection: Array.isArray(state.etiquetteIdsSelection) ? state.etiquetteIdsSelection : [],
    contenusSelection: Array.isArray(state.contenusSelection) ? state.contenusSelection : [],
    pageIndex: typeof state.pageIndex === 'number' && state.pageIndex >= 0 ? state.pageIndex : 0,
    pageSize: typeof state.pageSize === 'number' && state.pageSize > 0 ? state.pageSize : 10
  };
}
